// Insignia y metadatos de VERTICAL del negocio — fuente ÚNICA compartida por
// las pantallas de admin (Usuarios y Clientes, Suscripciones, …) para que las
// etiquetas/colores/opciones de filtro siempre COINCIDAN entre páginas.
// Espejo de VALID_VERTICALS en lealify-base/backend/lib/verticals.js.

export type Vertical = 'lealtad' | 'dental' | 'letsmove' | 'clublectura' | 'pos';

export const VERTICAL_META: Record<string, { label: string; cls: string }> = {
  lealtad:     { label: 'Lealtad', cls: 'bg-amber-100 text-amber-800 dark:bg-amber-500/20 dark:text-amber-300' },
  dental:      { label: 'Dental',  cls: 'bg-sky-100 text-sky-800 dark:bg-sky-500/20 dark:text-sky-300' },
  letsmove:    { label: 'Baile',   cls: 'bg-fuchsia-100 text-fuchsia-800 dark:bg-fuchsia-500/20 dark:text-fuchsia-300' },
  clublectura: { label: 'Club',    cls: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-500/20 dark:text-emerald-300' },
  pos:         { label: 'POS',     cls: 'bg-slate-100 text-slate-800 dark:bg-slate-500/20 dark:text-slate-300' },
};

// Opciones para los <select> de filtro (mismo orden/labels en todas las pantallas).
export const VERTICAL_FILTER_OPTIONS: Array<{ value: string; label: string }> = [
  { value: 'all',         label: 'Todas las verticales' },
  { value: 'lealtad',     label: 'Lealtad' },
  { value: 'dental',      label: 'Dental' },
  { value: 'letsmove',    label: "Baile (Let's Move)" },
  { value: 'clublectura', label: 'Club de lectura' },
  { value: 'pos',         label: 'POS' },
];

export const verticalLabel = (v?: string | null): string =>
  VERTICAL_META[v || 'lealtad']?.label || v || 'Lealtad';

export const VerticalBadge = ({ vertical }: { vertical?: string | null }) => {
  const meta = VERTICAL_META[vertical || 'lealtad'] || VERTICAL_META.lealtad;
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${meta.cls}`} title={`Vertical: ${meta.label}`}>
      {meta.label}
    </span>
  );
};

export default VerticalBadge;
